import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { EditListingPoliciesForm } from '../../forms';


import css from './EditListingPoliciesPanel.module.css';

const EditListingPoliciesPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    backButtonText,
    redirectAfterPrevTab,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData } = currentListing.attributes;
  
  const panelTitle = (
    <FormattedMessage id="EditListingPoliciesPanel.title" />
  );

  return (
    <div className={classes}>
      <div className={css.header}>
        <h1 className={css.title}>{panelTitle}</h1>
        <p className={css.number}>
          08
        </p>
      </div>
      <EditListingPoliciesForm
        className={css.form}
        publicData={publicData}
        initialValues={{ rules: publicData.rules, wifiName: publicData.wifiName, wifiPassword: publicData.wifiPassword, checkInCheckOut: publicData.checkInCheckOut, directions: publicData.directions, parking: publicData.parking, swap: publicData.swap, customPolicies: publicData.customPolicies || [] }}
        onSubmit={values => {
          const { 
            rules = '', 
            wifiName = '',
            wifiPassword = '',
            checkInCheckOut = '',
            directions = '',
            parking = '',
            swap,
            customPolicies = []
          } = values;
          
          const updateValues = {
            publicData: {
              rules,
              wifiName,
              wifiPassword,
              checkInCheckOut,
              directions,
              parking,
              swap,
              customPolicies
            },
          };
          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        saveActionMsg={submitButtonText}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        backButtonText={backButtonText}
        redirectAfterPrevTab={redirectAfterPrevTab}
        {...rest}
      />
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingPoliciesPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingPoliciesPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingPoliciesPanel;
